module.exports = __webpack_public_path__ + "static/media/toto_logo.65e2cf82.svg";